import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
interface IProps {
  totalImagesCount: number;
  totalFilteredCount: number;
}

export const FilteredImagesCounter = ({ totalImagesCount, totalFilteredCount }: IProps): ReactElement => {
  const { t } = useTranslator();
  return <div>{totalImagesCount > 0 && t('showing_x_images_of_y', { totalImagesCount, totalFilteredCount })}</div>;
};
